<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="ការទូទាត់ប្រាក់សម្រាប់អតិថិជន" name="2" v-if="allow_user('sa|ad|ca|sl|ac')"></el-tab-pane>
			<el-tab-pane label="ការប្រមូលប្រាក់អ្នកដឹកជញ្ជូន" name="3" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកដឹកជញ្ជូន" name="5" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកទៅទទួលកញ្ចប់ឥវ៉ាន់" name="6" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់អ្នកទីផ្សារ" name="7" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់ការិយាល័យ" name="8" v-if="allow_user('sa|ad|sl')"></el-tab-pane>
			<el-tab-pane label="ការទូទាត់ប្រាក់គណនេយ្យ" name="9" v-if="allow_user('sa')"></el-tab-pane>
		</el-tabs>
		<loading v-if="!loaded" />
		<div v-else>
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40" v-if="allow_user('sa|ad|ca|sl')">
					<md-field>
						<label>ស្វែងរកប្រត្តិបត្តិការតាមរយៈលេខកូដ ឬ ពាក្យសំគាល់</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				
				<div class="md-layout-item md-small-size-100 md-size-30" v-if="allow_user('sa|ad|ca|sl')">
					<md-field>
						<label>ឈ្មោះអ្នកគណនេយ្យ</label>
						<md-select placeholder="ឈ្មោះអ្នកគណនេយ្យ" v-model="search.text">
							<md-option v-for="accountant in accountant_list" :value="accountant.name">{{accountant.name}}</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30" v-if="allow_user('sa|ad|ca|sl')">
					<md-button class="md-raised md-primary" @click="searchHandler()"
						style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>
			<md-table>
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ប្រភេទប្រតិបត្តិការ</md-table-head>
					<md-table-head>ចំនួន</md-table-head>
					<md-table-head>កំណត់ចំណាំ</md-table-head>
					<md-table-head>ទូទាត់ដោយ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(transaction, index) in transactionList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>{{ transaction.hash_id }}<br>{{ transaction.name }}</md-table-cell>
					<md-table-cell>
						<span class="green" v-if="transaction.type == 'dep'">ដាក់ប្រាក់</span>
						<span class="late" v-if="transaction.type == 'wit'">ដកប្រាក់</span>
					</md-table-cell>
					<md-table-cell>{{ config.moneylify(transaction.total_usd, 'usd') }} + {{
						config.moneylify(transaction.total_khr, 'khr') }}</md-table-cell>
					<md-table-cell>{{ transaction.note }}</md-table-cell>
					<md-table-cell>{{transaction.created_by}}<br>{{ config.datelify(transaction.created_date)
						}}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/transactions/detail/' + transaction.tag_id +'/' + transaction.hash_id">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell colspan="2">
						<b>{{ config.moneylify(total_transaction_usd, 'usd') }} +
							{{config.moneylify(total_transaction_khr, 'khr') }}</b>
					</md-table-cell>
					<md-table-cell></md-table-cell>
					<md-table-cell></md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="transactionList.length == 0">មិនមានប្រតិបត្តិការ</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>

		<!-- <div v-if="tabName == 'ten'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ប្រតិបត្តិការ</h3>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ប្រភេទប្រតិបត្តិការ</label>
								<md-select placeholder="ប្រភេទប្រតិបត្តិការ" v-model="transaction.type"
									@md-selected="checkValidation()">
									<md-option value="dep">ដាក់ប្រាក់</md-option>
									<md-option value="wit">ដកប្រាក់</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះប្រតិបត្តិការ</label>
								<md-select placeholder="ឈ្មោះប្រតិបត្តិការ" v-model="transaction.tag"
									@md-selected="checkValidation()">
									<md-option v-for="tag in tagList" :value="tag.id">{{tag.name}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ចំនួនទឹកប្រាក់ដុល្លា</label>
								<md-input type="number" v-model="transaction.amount_usd"
									@keyup="checkValidation()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ចំនួនទឹកប្រាក់រៀល</label>
								<md-input type="number" v-model="transaction.amount_khr"
									@keyup="checkValidation()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំ (មិនចាំបាច់)</label>
								<md-input type="text" v-model="transaction.remark"
									@keyup="checkValidation()"></md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>សង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ប្រភេទប្រតិបត្តិការ</md-table-cell>
								<md-table-cell style="width: 5px">៖</md-table-cell>
								<md-table-cell>
									<span class="green" v-if="transaction.type == 'dep'">ដាក់ប្រាក់</span>
									<span class="late" v-if="transaction.type == 'wit'">ដកប្រាក់</span>
									<span v-if="transaction.type == ''">មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ចំនួនទឹកប្រាក់</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(transaction.amount_usd).length > 0">
										{{config.moneylify(transaction.amount_usd,'usd')}}</span><span
										v-else>មិនទាន់មាន</span> +
									<span
										v-if="String(transaction.amount_khr).length > 0">{{config.moneylify(transaction.amount_khr,
										'khr')}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(transaction.remark).length > 0">{{transaction.remark}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button :class="{'md-raised': true, 'md-primary': transaction.valid}" @click="post()">បង្កើត
					</md-button>
				</div>

			</div>
		</div> -->

		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		mounted() {
			if (!this.allow_user("sa|ad|sl|da|ac")) {
				this.$router.push('/dashboard');
			}
		},
		created() {
			this.$http.get(this.config.api + "/admin/get_user_data").then(data => {
				if (this.allow_user("ac")) { this.search.text = data.body.data.admin_username; }
				this.searchHandler();
			});
			if (this.allow_user("sa")) { this.get_accountant(); }
		},
		watch: {
			"tabName": function () {
				this.searchHandler();
			}
		},
		computed: {
			total_transaction_khr() {
                let total = 0;
                for (let i = 0; i < this.transactionList.length; i++) {
                    total = total + this.transactionList[i].total_khr;
                }
                return total;
            },
            total_transaction_usd() {
                let total = 0;
                for (let i = 0; i < this.transactionList.length; i++) {
                    total = total + this.transactionList[i].total_usd;
                }
                return total;
            }
		},
		data() {
			return {
				tabName: "2",
				loaded: false,
				// transaction: {
				// 	valid: false,
				// 	type: "",
				// 	tag: "",
				// 	amount_usd: 0,
				// 	amount_khr: 0,
				// 	remark: "",
				// },
				search: {
					text: "",
					tag: "",
				},
				loadMore: false,
				transactionList: [],
				accountant_list: []
			}
		},
		methods: {
			get_accountant(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/admin/get/list/" + offset).then(data => {

					this.accountant_list = data.body.data.filter(item => item.account_type === 'ac');
					this.loaded = true;
				});
			},
			// getSettings() {
			// 	this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
			// 		this.tagList = data.body.data.tag
			// 	})
			// },
			// checkValidation() {
			// 	if (String(this.transaction.type).length > 0 && String(this.transaction.amount_khr).length > 0 && String(this.transaction.amount_usd).length > 0 && String(this.transaction.tag).length > 0) {
			// 		if (parseFloat(this.transaction.amount_khr) > 0 || parseFloat(this.transaction.amount_usd) > 0) {
			// 			this.transaction.valid = true
			// 		}
			// 	} else {
			// 		this.transaction.valid = false
			// 	}
			// },
			// post() {
			// 	this.$http.post(this.config.api + "/admin/transaction/post", {
			// 		amount_khr: this.transaction.amount_khr,
			// 		amount_usd: this.transaction.amount_usd,
			// 		remark: this.transaction.remark,
			// 		type: this.transaction.type,
			// 		currency: this.transaction.currency,
			// 		tag: this.transaction.tag
			// 	}).then(res => {
			// 		if (res.body.status == 'success') {
			// 			this.$notification.notify({
			// 				message: "ប្រតិបត្តិការបង្កើតឡើងដោយជោគជ័យ។",
			// 				icon: 'done',
			// 				type: 'success'
			// 			})

			// 			this.tabName = 'first'
			// 			this.searchHandler();

			// 		}
			// 	})
			// },
			searchHandler(more = false) {
				this.loaded = more ? true : false;
				this.$http.post(this.config.api + "/admin/transaction/search", {
					text: this.search.text,
					tag: this.tabName,
					offset: more ? this.transactionList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == 50) this.loadMore = true;
					else this.loadMore = false;
					this.transactionList = more ? this.transactionList.concat(data.body.data) : data.body.data;
				})
			},
			reset() {
				this.transaction = {
					valid: false,
					type: "",
					tag: "",
					amount_usd: 0,
					amount_khr: 0,
					remark: "",
					// currency: "usd"
				}
			}
			// onCancel() {
			// 	this.deleteSelected = ""
			// 	this.deleteDialogActive = false
			// }
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Transactions/View.vue